/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
class NegotiateService extends __BaseService {
  static readonly NegotiateDataHubNegotiatePath = '/datahub/negotiate';
  static readonly NegotiatePublicNegotiatePath = '/public/negotiate';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param params The `NegotiateService.NegotiateDataHubNegotiateParams` containing the following parameters:
   *
   * - `session`:
   *
   * - `group`:
   */
  NegotiateDataHubNegotiateResponse(params: NegotiateService.NegotiateDataHubNegotiateParams): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.session != null) __params = __params.set('session', params.session.toString());
    if (params.group != null) __params = __params.set('group', params.group.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/datahub/negotiate`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param params The `NegotiateService.NegotiateDataHubNegotiateParams` containing the following parameters:
   *
   * - `session`:
   *
   * - `group`:
   */
  NegotiateDataHubNegotiate(params: NegotiateService.NegotiateDataHubNegotiateParams): __Observable<Blob> {
    return this.NegotiateDataHubNegotiateResponse(params).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param params The `NegotiateService.NegotiatePublicNegotiateParams` containing the following parameters:
   *
   * - `session`:
   *
   * - `group`:
   */
  NegotiatePublicNegotiateResponse(params: NegotiateService.NegotiatePublicNegotiateParams): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.session != null) __params = __params.set('session', params.session.toString());
    if (params.group != null) __params = __params.set('group', params.group.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/public/negotiate`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param params The `NegotiateService.NegotiatePublicNegotiateParams` containing the following parameters:
   *
   * - `session`:
   *
   * - `group`:
   */
  NegotiatePublicNegotiate(params: NegotiateService.NegotiatePublicNegotiateParams): __Observable<Blob> {
    return this.NegotiatePublicNegotiateResponse(params).pipe(
      __map(_r => _r.body as Blob)
    );
  }
}

module NegotiateService {

  /**
   * Parameters for NegotiateDataHubNegotiate
   */
  export interface NegotiateDataHubNegotiateParams {
    session?: null | string;
    group?: null | string;
  }

  /**
   * Parameters for NegotiatePublicNegotiate
   */
  export interface NegotiatePublicNegotiateParams {
    session?: null | string;
    group?: null | string;
  }
}

export { NegotiateService }
